<div class="modern-dashboard">
  <!-- Dashboard Header -->
  <div class="dashboard-header">
    <div class="header-content">
      <div class="welcome-section">
        <h1 class="welcome-title bangla-heading">Welcome to Digital Union</h1>
        <p class="welcome-subtitle bangla-title">{{unionDomain.unionData.union_name}} Management Dashboard</p>
        <div class="location-info">
          <i class="fas fa-map-marker-alt"></i>
          <span class="bangla-text">{{unionDomain.unionData.upozilla_name}}, {{unionDomain.unionData.zilla_name}}</span>
        </div>
      </div>
      <div class="header-actions">
        <div class="current-date">
          <i class="fas fa-calendar-alt"></i>
          <span>{{currentDate | date:'fullDate'}}</span>
        </div>
        <button class="btn-primary-modern refresh-btn" (click)="refreshDashboard()">
          <i class="fas fa-sync-alt"></i>
          Refresh Data
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="loading-text">Loading dashboard data...</p>
  </div>

  <!-- Statistics Cards -->
  <div class="stats-grid" [class.loading]="isLoading">
    <div class="stat-card modern-card fade-in">
      <div class="stat-icon assessments">
        <i class="fas fa-clipboard-list"></i>
      </div>
      <div class="stat-content">
        <h3 class="stat-number">{{dashboardStats.totalAssessments || 0}}</h3>
        <p class="stat-label">Total Assessments</p>
        <div class="stat-trend" [ngClass]="dashboardStats.assessmentGrowth >= 0 ? 'positive' : 'negative'">
          <i class="fas" [ngClass]="dashboardStats.assessmentGrowth >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          <span>{{dashboardStats.assessmentGrowth >= 0 ? '+' : ''}}{{dashboardStats.assessmentGrowth || 0}}% from last month</span>
        </div>
      </div>
    </div>

    <div class="stat-card modern-card fade-in">
      <div class="stat-icon collections">
        <i class="fas fa-money-bill-wave"></i>
      </div>
      <div class="stat-content">
        <h3 class="stat-number">৳{{dashboardStats.totalCollection || 0 | number}}</h3>
        <p class="stat-label">Tax Collection</p>
        <div class="stat-trend" [ngClass]="dashboardStats.collectionGrowth >= 0 ? 'positive' : 'negative'">
          <i class="fas" [ngClass]="dashboardStats.collectionGrowth >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          <span>{{dashboardStats.collectionGrowth >= 0 ? '+' : ''}}{{dashboardStats.collectionGrowth || 0}}% from last month</span>
        </div>
      </div>
    </div>

    <div class="stat-card modern-card fade-in">
      <div class="stat-icon wards">
        <i class="fas fa-building"></i>
      </div>
      <div class="stat-content">
        <h3 class="stat-number">{{dashboardStats.totalWards || 0}}</h3>
        <p class="stat-label">Active Wards</p>
        <div class="stat-trend neutral">
          <i class="fas fa-minus"></i>
          <span>No change</span>
        </div>
      </div>
    </div>

    <div class="stat-card modern-card fade-in">
      <div class="stat-icon users">
        <i class="fas fa-users"></i>
      </div>
      <div class="stat-content">
        <h3 class="stat-number">{{dashboardStats.activeUsers || 0}}</h3>
        <p class="stat-label">Active Users</p>
        <div class="stat-trend" [ngClass]="dashboardStats.userGrowth >= 0 ? 'positive' : 'negative'">
          <i class="fas" [ngClass]="dashboardStats.userGrowth >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          <span>{{dashboardStats.userGrowth >= 0 ? '+' : ''}}{{dashboardStats.userGrowth || 0}}% from last month</span>
        </div>
      </div>
    </div>

    <!-- SMS Balance Card -->
    <div class="stat-card modern-card fade-in">
      <div class="stat-icon sms-balance">
        <i class="fas fa-sms"></i>
      </div>
      <div class="stat-content">
        <h3 class="stat-number" *ngIf="!smsBalanceLoading && !smsBalanceError">
          {{smsBalance | number:'1.0-0'}}
        </h3>
        <h3 class="stat-number" *ngIf="smsBalanceLoading">
          <i class="fas fa-spinner fa-spin"></i>
        </h3>
        <h3 class="stat-number error" *ngIf="smsBalanceError">
          <i class="fas fa-exclamation-triangle"></i>
        </h3>
        <p class="stat-label bangla-text">বাকি SMS</p>
        <div class="stat-trend" [ngClass]="smsBalance > 100 ? 'positive' : smsBalance > 50 ? 'warning' : 'negative'">
          <i class="fas" [ngClass]="smsBalance > 100 ? 'fa-check-circle' : smsBalance > 50 ? 'fa-exclamation-circle' : 'fa-times-circle'"></i>
          <span *ngIf="!smsBalanceError" class="bangla-text">
            {{smsBalance > 100 ? 'পর্যাপ্ত SMS আছে' : smsBalance > 50 ? 'SMS কম হয়ে যাচ্ছে' : 'SMS রিচার্জ করুন'}}
          </span>
          <span *ngIf="smsBalanceError" class="bangla-text">
            ব্যালেন্স লোড করতে ব্যর্থ
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Dashboard Content Grid -->
  <div class="dashboard-grid">
    <!-- Recent Activities -->
    <div class="dashboard-widget modern-card slide-up">
      <div class="widget-header">
        <h3 class="widget-title">Recent Activities</h3>
        <button class="widget-action">
          <i class="fas fa-ellipsis-h"></i>
        </button>
      </div>
      <div class="widget-content">
        <div class="activity-list">
          <div class="activity-item" *ngFor="let activity of recentActivities">
            <div class="activity-icon" [ngClass]="activity.type">
              <i [class]="activity.icon"></i>
            </div>
            <div class="activity-details">
              <p class="activity-text">{{activity.description}}</p>
              <span class="activity-time">{{activity.timestamp | date:'short'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Actions -->
    <div class="dashboard-widget modern-card slide-up">
      <div class="widget-header">
        <h3 class="widget-title">Quick Actions</h3>
      </div>
      <div class="widget-content">
        <div class="quick-actions-grid">
          <a routerLink="/admin/assessment-create" class="quick-action-item">
            <div class="action-icon">
              <i class="fas fa-plus"></i>
            </div>
            <span class="action-label">New Assessment</span>
          </a>
          <a routerLink="/admin/tax-collection-list" class="quick-action-item">
            <div class="action-icon">
              <i class="fas fa-money-bill-wave"></i>
            </div>
            <span class="action-label">Tax Collection</span>
          </a>
          <a routerLink="/admin/assessment-print" class="quick-action-item">
            <div class="action-icon">
              <i class="fas fa-print"></i>
            </div>
            <span class="action-label">Print Documents</span>
          </a>
          <a routerLink="/admin/ward-manage" class="quick-action-item">
            <div class="action-icon">
              <i class="fas fa-cogs"></i>
            </div>
            <span class="action-label">Manage Wards</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Monthly Overview -->
    <div class="dashboard-widget modern-card slide-up">
      <div class="widget-header">
        <h3 class="widget-title">Monthly Overview</h3>
        <div class="widget-controls">
          <select class="form-control form-control-sm" 
                  [(ngModel)]="selectedMonthPeriod"
                  (change)="onMonthPeriodChange(selectedMonthPeriod)"
                  [disabled]="isLoading">
            <option *ngFor="let option of monthPeriodOptions" [value]="option.value">
              {{option.label}}
            </option>
          </select>
        </div>
      </div>
      <div class="widget-content">
        <div class="overview-metrics">
          <div class="metric-item">
            <div class="metric-icon">
              <i class="fas fa-file-alt"></i>
            </div>
            <div class="metric-info">
              <h4>{{monthlyStats.newAssessments || 0}}</h4>
              <p>New Assessments</p>
            </div>
          </div>
          <div class="metric-item">
            <div class="metric-icon">
              <i class="fas fa-receipt"></i>
            </div>
            <div class="metric-info">
              <h4>৳{{monthlyStats.monthlyCollection || 0 | number}}</h4>
              <p>Monthly Collection</p>
            </div>
          </div>
          <div class="metric-item">
            <div class="metric-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="metric-info">
              <h4>{{monthlyStats.completedTasks || 0}}</h4>
              <p>Completed Tasks</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- System Status -->
    <div class="dashboard-widget modern-card slide-up">
      <div class="widget-header">
        <h3 class="widget-title">System Status</h3>
        <span class="status-indicator online">
          <i class="fas fa-circle"></i>
          Online
        </span>
      </div>
      <div class="widget-content">
        <div class="status-items">
          <div class="status-item">
            <div class="status-info">
              <span class="status-label">Database</span>
              <span class="status-value good">Good</span>
            </div>
            <div class="status-bar">
              <div class="status-progress" style="width: 95%"></div>
            </div>
          </div>
          <div class="status-item">
            <div class="status-info">
              <span class="status-label">Server Response</span>
              <span class="status-value good">Good</span>
            </div>
            <div class="status-bar">
              <div class="status-progress" style="width: 92%"></div>
            </div>
          </div>
          <div class="status-item">
            <div class="status-info">
              <span class="status-label">Storage</span>
              <span class="status-value warning">75% Used</span>
            </div>
            <div class="status-bar">
              <div class="status-progress warning" style="width: 75%"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>